<div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Audience name" placeholder="Enter your audience name"
                type="text" [control]="form.get('audienceTypeName')" formControlName="audienceTypeName"
                [required]="true" [customErrorMessages]="customErrorMessages.audienceTypeName">
            </app-input>
        </div>

        <div>
            <div class="note-text">Description
                <!-- <span class="optional">(optional)</span> -->
            </div>
            <div class="note-container">
                <div>
                    <textarea class="note-input" formControlName="audienceDescription" (input)="autoResize($event)"
                        placeholder="Enter your description" [class.error]="hasDescriptionError()">
            </textarea>
                </div>
            </div>
            <div *ngIf="hasDescriptionError()" class="error-message">
                {{ getDescriptionError() }}
            </div>
        </div>

        <div class="toggle-container">
            <label class="toggle-text">
                <span>Status</span>
                <input id="status" formControlName="status" type="checkbox" class="toggle-input" />
                <span class="toggle-switch"></span>
            </label>
        </div>

        <button type="submit" style="display: none;" #submitBtn></button>
    </form>
</div>